import { Route, Switch } from "react-router-dom";

import ThreeDPdpImagesPage from "@faire/prototype-playground/workspace/jz/3d-pdp-images";

export function JasmineZhangRoutes() {
  return (
    <Switch>
      <Route path="/jz/3d-pdp-images" component={ThreeDPdpImagesPage} />
    </Switch>
  );
}

export const slug = "jz";
